import * as React from 'react';
import { createDatesArray } from '../../utils';
import { format } from 'date-fns';
import { HeaderType } from '../PriceMatrix';
import { withTheme, WithThemeProps } from '../../theme';
import classnames from 'classnames';

interface Props {
	minDate: Date;
	maxDate: Date;
	type: HeaderType;
	onArrowClick?: (type: HeaderType, direction: 'next' | 'prev') => void;
	innerRef?: React.LegacyRef<HTMLDivElement>;
}

@withTheme
export class Outbound extends React.Component<Partial<WithThemeProps> & Props> {
	private fill(): Date[] {
		return createDatesArray(this.props.minDate, this.props.maxDate);
	}

	public arrowClick(dir: 'next' | 'prev') {
		this.props.onArrowClick && this.props.onArrowClick(this.props.type, dir);
	}

	public render(): React.ReactNode {
		const dates = this.fill(),
			style = this.props.theme.OutboundStyles;

		return (
			<div
				className={classnames(style.container, {
					[style.container_row]: this.props.type === HeaderType.Return,
					[style.container_col]: this.props.type === HeaderType.Outbound
				})}
			>
				<div className={style.nav}>
					<div className={style.label}>{this.props.type === HeaderType.Outbound ? 'Outbound' : 'Return'}</div>

					<div className={style.arrows}>
						<div
							className={style.arrow_prev}
							onClick={() => this.arrowClick(this.props.type === HeaderType.Return ? 'prev' : 'next')}
						/>
						<div
							className={style.arrow_next}
							onClick={() => this.arrowClick(this.props.type === HeaderType.Return ? 'next' : 'prev')}
						/>
					</div>
				</div>

				<div className={style.wrapper} ref={this.props.innerRef}>
					{dates.map((date, index) => {
						return (
							<div key={index} className={style.day}>
								<span>{format(date, 'd MMM')}</span>
								<span className={style.day_dow}>{format(date, 'EEE')}</span>
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}
